import TextArea from 'antd/es/input/TextArea';
import React, { useState } from 'react';

function CharacterLimitedTextArea({ placeholder, maxLength, setDescription, description }) {

    const handleChange = (event) => {
        setDescription(event.target.value);
    };

    const remainingCharacters = maxLength - description.length;
    const characterCountString = `${remainingCharacters} / ${maxLength}`;
    
    return (
        <div>
            <TextArea
                placeholder={placeholder}
                maxLength={maxLength}
                value={description}
                required
                onChange={handleChange}
                style={{
                    width: "100%",
                    height: "160px",
                    borderRadius: "8px",
                    border: "1px solid",
                    padding: "1rem",
                    color: "#79767B",
                    fontFamily: "Roboto",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: "300",
                    lineHeight: "normal",
                    resize: "none"
                }}
            />
            <p>{characterCountString}</p>
        </div>
    );
}

export default CharacterLimitedTextArea;